export const DEFAULT_NAME = 'Umi Max';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const FLOW_RATE = 'GB';
export const FLOW_PRICE = '美元';
export const DURATION_MONTH = '月';
export const FLOW_MAX = 10000000;
export const SYNC_MESSAGE = '同步时间与数据量相关，请耐心等待';

export const TRAFFIC_NAME = '流量';
export const NUMBER_NAME = '个数';

export const PRICE_MAX = 99999999.99;
export const INT_MAX = 2147483647;

export const PACKAGE_TYPE_LABEL: Record<number, string> = {
  0: "app套餐",
  1: "sdk套餐",
  // 2: "appstore套餐",
};
